'use client';

import { useState } from 'react';
import styles from './Contacts.module.css';
import { Mail, MailWarning, AlertTriangle, CheckCircle } from 'lucide-react';
import { toast } from 'react-hot-toast';

export default function ContactsPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error('Name is required', { icon: <AlertTriangle color="#ff4a4a" /> });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address', { icon: <MailWarning color="#ff4a4a" /> });
      return;
    }

    if (!message.trim()) {
      toast.error('Message cannot be empty', { icon: <AlertTriangle color="#ff4a4a" /> });
      return;
    }

    setLoading(true);

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message }),
      });

      if (res.ok) {
        toast.success('Message sent successfully!', { icon: <CheckCircle color="#ff756b" /> });
        setName('');
        setEmail('');
        setMessage('');
      } else {
        toast.error('Failed to send message.', { icon: <AlertTriangle color="#ff4a4a" /> });
      }
    } catch {
      toast.error('Server error. Please try again later.', { icon: <AlertTriangle color="#ff4a4a" /> });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Contacts</h2>

      <div className={styles.infoBlock}>
        <div className={styles.infoItem}>
          <Mail size={18} className={styles.icon} />
          <a href="mailto:info@miraclassic.com" className={styles.link}>
            info@miraclassic.com
          </a>
        </div>
      </div>

      <form onSubmit={handleSubmit} className={styles.form} noValidate>
        <input
          type="text"
          placeholder="Your name"
          className={styles.input}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Your email"
          className={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <textarea
          placeholder="Your message"
          className={styles.textarea}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <button type="submit" className={styles.button} disabled={loading}>
          {loading ? 'Sending…' : 'Send'}
        </button>
      </form>
    </div>
  );
}
